import type { AchievementProfile, GameStateV2 } from '../game'
import { supabase } from './supabase'

export interface CloudProgress {
  gameState: unknown
  achievements: unknown
  updatedAt: string
}

function requireClient() {
  if (!supabase) throw new Error('La sincronización en la nube no está configurada.')
  return supabase
}

export async function loadCloudProgress(userId: string): Promise<CloudProgress | null> {
  const { data, error } = await requireClient()
    .from('user_progress')
    .select('game_state, achievements, updated_at')
    .eq('user_id', userId)
    .maybeSingle()

  if (error) throw error
  if (!data) return null
  return {
    gameState: data.game_state,
    achievements: data.achievements,
    updatedAt: data.updated_at,
  }
}

export async function saveCloudProgress(
  userId: string,
  gameState: GameStateV2 | null,
  achievements: AchievementProfile,
): Promise<string> {
  const updatedAt = new Date().toISOString()
  const { error } = await requireClient().from('user_progress').upsert({
    user_id: userId,
    game_state: gameState,
    achievements,
    updated_at: updatedAt,
  }, { onConflict: 'user_id' })

  if (error) throw error
  return updatedAt
}
